/**
 * 正则表达式模式，包含一些常见的公共正则表达式
 * https://c.runoob.com/front-end/854/
 */
const regexPatterns = {
  /** 手机号 */
  phone: /^1[3-9]\d{9}$/,
  /** 座机 */
  tel: /\d{3}-\d{8}|\d{4}-\d{7}/,
  /** 手机号或者座机 */
  telPhone: /(^1[3-9]\d{9}$)|(\d{3}-\d{8}|\d{4}-\d{7})/,
  /** http链接 */
  url: /^(http|https):\/\/[^\s/$.?#].[^\s]*$/,
  /** 身份证号 */
  idCard: /^[1-9]\d{5}(19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[Xx\d]$/,
  /** 电子邮箱 */
  email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  /** 中国邮编 */
  postalCode: /^[1-9]\d{5}$/,
  /** 统一社会信用代码 */
  creditCode: /^[0-9A-Z]{18}$/,
  /** 正整数和0 */
  integral: /^\d+$/,
  /** 正数、负数、和小数 */
  number: /^(-|\+)?\d+(\.\d+)?$/,
  /** 正整数 */
  positiveInteger: /^\d+$/,
  /** 
   * 传真 
   * 1.^(?:\d{3,4}-)? 代表开头填写3到4位数字（非必填写）
   * 2.\d{7,8} 代表7到8位数字 （必填项）
   * 3.(?:-\d{1,6})?$ 代表结尾1到6位数字(非必填写)
   * */
  fax: /^(?:\d{3,4}-)?\d{7,8}(?:-\d{1,6})?$/,
};

export default regexPatterns;
